export class PayUMoneyPayment {
    Id: number;
    FirstName: string;
    Amount: string;
    ProductInfo: string;
    Email: string;
    Phone: string;
    MobileNo: string;
    Key: string;
    TxnId: string;
    Hash: string;
    SUrl: string;
    FUrl: string;
    Service_Provider: string;
    PrasadOrderId:number;
    PerformPujaOnBehalf: string;
    PujaDate: Date;
    YourWish: string;
    PujaTithi: string;
    PaymentMode: string;
    PujaId: number;
    Status: string;
}



// WEBPACK FOOTER //
// ./src/app/prasad-order/pay-u-money-payment.ts